import React from 'react';
const SHOTS = {
  modal: 'https://cdn.magicpatterns.com/patterns/figma-images/AUpeuU2dG48jaLy3h8yv4P/46-196.png',
  generator: 'https://cdn.magicpatterns.com/patterns/figma-images/AUpeuU2dG48jaLy3h8yv4P/46-212.png',
  copilot: 'https://cdn.magicpatterns.com/patterns/figma-images/AUpeuU2dG48jaLy3h8yv4P/46-216.png'
};
type StepLabelProps = {
  step: string;
  children: React.ReactNode;
};
function StepLabel({
  step,
  children
}: StepLabelProps) {
  return <p className="mb-2.5 flex items-baseline gap-2 text-xs text-[#7A6A5C]" data-id="element-494" data-mp="1g2sioupqvspq">
      <span className="font-semibold tabular-nums text-[#B56A2E]" data-id="element-495" data-mp="1kx6egy8bk1ux">{step}</span>
      {children}
    </p>;
}

/** First prototype board (Kronos+): layout sketch → scenario flow → copilot → scenario generator. */
export function PrototypeMock() {
  return <div className="rounded-2xl border border-[#FFE0C2] bg-[#FFF7F0] p-4 md:p-8" data-id="element-496" data-mp="x5hj1907ax9r">
      <StepLabel step="1" data-id="element-497" data-mp="12543a2eg5ds2">Layout sketch: where the agent lives</StepLabel>
      <div className="grid grid-cols-[1fr_auto] gap-3 md:gap-4" data-id="element-498" data-mp="1276swlbot4w9">
        <div className="grid min-h-[120px] place-items-center rounded-lg border border-[#B9B9B9] bg-[#DADADA] px-4 text-center text-xs text-[#3A3A3A] md:min-h-[160px] md:text-sm" data-id="element-499" data-mp="2nomp4w2hdpw5">
          Left rail · Main canvas (navigation)
        </div>
        <div className="grid w-[32vw] max-w-[180px] place-items-center rounded-lg border border-[#B9B9B9] bg-[#DADADA] px-3 text-center text-xs text-[#3A3A3A] md:text-sm" data-id="element-500" data-mp="2xlret5vjc3hp">
          Chat and live feedback
        </div>
      </div>

      <div className="mt-8 grid gap-6 md:grid-cols-[minmax(0,1.7fr)_minmax(0,1fr)] md:gap-8" data-id="element-501" data-mp="200vc1q9498tt">
        <div data-id="element-502" data-mp="2epri5hrm4brs">
          <StepLabel step="2" data-id="element-503" data-mp="2epj2xj80oudf">Configure a what-if scenario</StepLabel>
          <img src={SHOTS.modal} alt="Configure Scenario modal: scenario name, category, role title, headcount slider, salary and start date, with Run Scenario button" loading="lazy" className="w-full rounded-lg shadow-[0_8px_24px_rgba(90,60,30,0.12)]" data-id="element-504" data-mp="29yj5mcuzkaae" />
        </div>
        <div data-id="element-505" data-mp="3hcwnl93ar92w">
          <StepLabel step="3" data-id="element-506" data-mp="3hbbu7mspxw6m">Copilot flags it first</StepLabel>
          <img src={SHOTS.copilot} alt="Kronos+ Copilot chat noticing a 15% AWS cost spike and offering to create a cost-optimization scenario" loading="lazy" className="mx-auto w-full max-w-[260px] rounded-lg shadow-[0_8px_24px_rgba(90,60,30,0.12)]" data-id="element-507" data-mp="3may8lzka9ih0" />
        </div>
      </div>

      <div className="mt-8" data-id="element-508" data-mp="2yeke1m8h3x6s">
        <StepLabel step="4" data-id="element-509" data-mp="2yfc128o08mlg">See the impact on runway</StepLabel>
        <img src={SHOTS.generator} alt="Scenario Generator: parameters panel, AI analysis, baseline vs scenario runway and a projected cash balance chart" loading="lazy" className="w-full rounded-lg shadow-[0_8px_24px_rgba(90,60,30,0.12)]" data-id="element-510" data-mp="33ddkiupcenxg" />
      </div>
    </div>;
}